export default "__VITE_ASSET__FNtJvJKT__"